import { createVanIconComponent } from "./van"

const BalanceList = createVanIconComponent("balance-list")
export default BalanceList
